<template>
    <div id="app" :dir="lang === 'en' ? 'ltr' : 'rtl'">
        <ion-app class="auto-login" v-if="showAutoLogin">
            <span><ion-spinner name="crescent" color="primary"></ion-spinner></span>
            {{ $t('master.loggingIn') }}
        </ion-app>
        <ion-app v-else-if="isMobile || windowWidth < 1200">
            <ion-menu side="start" swipe-gesture="false" contentId="1">
                <menu-left />
            </ion-menu>
            <ion-page class="ion-page" main>
                <nav-bar v-if="!noNav.find(path => path === $route.path)" />
                <main-page fullscreen />
            </ion-page>
        </ion-app>
        <ion-app v-else>
            <desktop-wrapper />
        </ion-app>
        <ion-menu-controller></ion-menu-controller>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import MenuLeft from './layout/MenuLeft'
import NavBar from './layout/NavBar'
import MainPage from './layout/MainPage'
import DesktopWrapper from './layout/DesktopWrapper'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'

import echo from '@/utils/echo.js'
// import AppFooter from "./layout/AppFooter";

export default {
    name: 'App',
    components: { MainPage, NavBar, MenuLeft, DesktopWrapper },
    data() {
        return {
            noNav: ['/login'],
            noNotifications: ['/messages'],
            isMobile,
            showAutoLogin: this.token && !this.user
        }
    },
    mounted() {
        if (this.token && !this.user) {
            this.showAutoLogin = true
            this.$store.dispatch('autoLogin', {
                token: this.token
            })
        }
        const locale = this.lang || localStorage.getItem('locale') || 'ar'
        if (!this.user) {
            this.$i18n.locale = locale
            this.$store.dispatch('setLanguage', locale)
        }
        if (this.user) {
            this.$i18n.locale = this.lang
            this.$store.dispatch('setLanguage', locale)
        }

        window.Echo = echo
    },
    computed: mapGetters(['user', 'token', 'lang', 'getMessagesCount', 'error', 'getNotificationsCount']),
    watch: {
        token(token, oldToken) {
            if (!token && oldToken) {
                this.showAutoLogin = false
            }
        },
        lang(lang, oldLang) {
            if (lang && lang !== oldLang) {
                this.$i18n.locale = lang
                this.$store.dispatch('setLanguage', lang)
            }
        },
        user(user, oldUser) {
            if (!oldUser && user) {
                const locale = this.lang || localStorage.getItem('locale') || 'ar'
                this.$i18n.locale = locale
                this.$store.dispatch('setLanguage', locale)
                this.$store.dispatch('fetchNotificationsCount')
                if (window.plugins) {
                    window.plugins.OneSignal.sendTag('email', user.email)
                }
                window.Echo.connector.pusher.config.auth.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                window.Echo.private(`messages.${this.user.id}`).listen('NewMessage', () => {
                    this.$store.dispatch('fetchNotificationsCount')
                })
                window.Echo.private(`banned.${this.user.id}`).listen('Banned', () => {
                    this.$store.dispatch('logout').then(() => this.$router.push('/login'))
                })
                window.Echo.private(`App.User.${this.user.id}`).notification(notification => {
                    const message = this.lang == 'en' ? notification['messageEN'] : notification['messageAR']
                    const title = this.lang == 'en' ? notification['titleEN'] : notification['titleAR']
                    if (!this.noNotifications.find(path => path === this.$route.path)) {
                        this.$snotify.simple(message, title).on('hidden', () => {
                            this.$store.dispatch('clearNotification')
                        })
                    }
                    this.$store.dispatch('fetchNotificationsCount')
                })
            }
        },
        error(error, oldError) {
            if (!oldError && error) {
                this.$snotify.error(error.error).on('hidden', () => {
                    this.$store.dispatch('clearError')
                })
            }
        }
    }
}
</script>

<style lang="scss">
@import '~vue-snotify/styles/material';
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
.w-100 {
    width: 100%;
}
.w-50 {
    width: 50%;
}
:root {
    --ion-color-primary: #188665;
    --ion-color-primary-rgb: 24, 134, 101;
    --ion-color-primary-contrast: #ffffff;
    --ion-color-primary-contrast-rgb: 255, 255, 255;
    --ion-color-primary-shade: #157659;
    --ion-color-primary-tint: #2f9274;

    --ion-color-secondary: #114f64;
    --ion-color-secondary-rgb: 17, 79, 100;
    --ion-color-secondary-contrast: #ffffff;
    --ion-color-secondary-contrast-rgb: 255, 255, 255;
    --ion-color-secondary-shade: #0f4658;
    --ion-color-secondary-tint: #296174;
}
a {
    text-decoration: none;
}
.error-message {
    color: red;
    font-size: 11px;
}

.snotifyToast__title {
    font-size: 16px;
    font-weight: 600;
}
.snotifyToast__message {
    font-size: 14px;
}
.snotifyToast__inner {
    text-align: start;
    padding: 8px;
}

.auto-login {
    background-color: #222428 !important;
    color: white !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    font-size: 24px !important;
    font-weight: bold !important;
}
.inline-block {
    display: inline-block;
}

.icon-img-xs {
    height: 20px;
    width: 20px;
}
.icon-img-sm {
    height: 25px;
    width: 25px;
}
.icon-img {
    height: 30px;
    width: 30px;
}
.icon-img-lg {
    height: 35px;
    width: 35px;
}

@media (min-width: 1200px) {
    .grey-background {
        background-color: #f5f5f5;
        --background: #f5f5f5;
    }
}
</style>
